import { MapPin, BadgeCheck } from "lucide-react";
import { Reveal, ChapterHeading } from "@/components/Reveal";
import { Crown } from "@/components/brand";

const QUOTES = [
  {
    quote: "Two days after my accident I had a doctor, a rental car, and an attorney who actually answered the phone. I cried from relief.",
    name: "Marisol G.",
    city: "Phoenix, AZ",
    testId: "testimonials-card-1",
  },
  {
    quote: "The adjuster kept lowballing me. The Queens connected me with a litigator who settled for four times the original offer.",
    name: "Danielle R.",
    city: "Las Vegas, NV",
    testId: "testimonials-card-2",
  },
  {
    quote: "They handled the tow, the body shop, even the MRI scheduling. I never paid a dollar out of pocket while my case resolved.",
    name: "Terrence W.",
    city: "Dallas, TX",
    testId: "testimonials-card-3",
  },
];

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="scroll-mt-24 py-24 sm:py-32 px-4 sm:px-8 bg-[#071A2B]/60">
    <div className="max-w-7xl mx-auto">
      <ChapterHeading
        eyebrow="04 // TESTIMONIALS & TRUST"
        title="Real Stories of Relief When Everything Felt Overwhelming"
        eyebrowTestId="testimonials-chapter-num"
        titleTestId="testimonials-headline"
      />
      <div className="mt-14 grid md:grid-cols-3 gap-6">
        {QUOTES.map((q, i) => (
          <Reveal key={q.name} delay={i * 0.1}>
            <figure
              data-testid={q.testId}
              className="h-full bg-[#092237] border border-[#C9A24B]/20 p-8 flex flex-col hover:border-[#C9A24B]/50 hover:-translate-y-1 transition-all duration-500"
            >
              <div className="flex items-center gap-1.5">
                {[0, 1, 2].map((n) => (
                  <Crown key={n} className="w-5 h-4" />
                ))}
              </div>
              <blockquote className="mt-6 font-editorial italic text-base sm:text-lg text-[#D4DFE6] leading-relaxed flex-1">
                &ldquo;{q.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-7 pt-5 border-t border-[#C9A24B]/15 flex items-center justify-between">
                <div>
                  <p className="font-display font-bold text-sm text-[#FBF8F2] tracking-wider">{q.name}</p>
                  <p className="mt-1 flex items-center gap-1 text-xs text-[#8EA3B0]">
                    <MapPin className="w-3 h-3 text-[#C9A24B]" /> {q.city}
                  </p>
                </div>
                <span className="flex items-center gap-1 font-data text-[9px] tracking-[0.18em] uppercase text-[#10B981]">
                  <BadgeCheck className="w-3.5 h-3.5" /> Verified
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
